import LoadingUtil from '../../core/util/loading_util';
import { TooltipAttrModel } from '../models/tooltip_model';
import { VariationAction } from './variation_action';
import { TableTxFilterHeaderModel } from '../models/table_tx_filter_header_model';
import { AdobeAnalyticsData } from '../../core/models/analytics/adobe_analytics_data';
import { TypedEvent } from '../../core/typed_event';
import { isIe } from '../../core/util/browser_util';

enum UrlParamKey {
  SortDir = 'sortDir',
  Page = 'page',
  GrpSpec = 'grpSpec',
  GrpSpec1 = 'grpSpec1',
  GrpSpec2 = 'grpSpec2',
  GrpSpec3 = 'grpSpec3',
  GrpSpec4 = 'grpSpec4',
  GrpSpec5 = 'grpSpec5',
  GrpSpec6 = 'grpSpec6',
  GrpSpec7 = 'grpSpec7',
  GrpSpec8 = 'grpSpec8',
  GrpSpec9 = 'grpSpec9',
  GrpSpec10 = 'grpSpec10',
  GrpSpec11 = 'grpSpec11',
  GrpSpec12 = 'grpSpec12',
  GrpSpec13 = 'grpSpec13',
  GrpSpec14 = 'grpSpec14',
  GrpSpec15 = 'grpSpec15',
  GrpSpec16 = 'grpSpec16',
  GrpSpec17 = 'grpSpec17',
  GrpSpec18 = 'grpSpec18',
  GrpSpec19 = 'grpSpec19',
  GrpSpec20 = 'grpSpec20',
  GrpSpec21 = 'grpSpec21',
  GrpSpec22 = 'grpSpec22',
  GrpSpec23 = 'grpSpec23',
  GrpSpec24 = 'grpSpec24',
  GrpSpec25 = 'grpSpec25',
  GrpSpec26 = 'grpSpec26',
  GrpSpec27 = 'grpSpec27',
  GrpSpec28 = 'grpSpec28',
  GrpSpec29 = 'grpSpec29',
  GrpSpec30 = 'grpSpec30',
  sellUnit = 'sellUnit'
}

enum Sort {
  asc = '1',
  desc = '2'
}

const SELECTED_CLASS = 'is-selected';
const TABLE_GROUP_SPEC_COL = 'table_group_spec_col_';
export const DATA_HEADER_COLS = 'data-header-cols';

export default class TableTooltipAction {
  static readonly SEND_VARIATION_SEARCH_EVENT = new TypedEvent<AdobeAnalyticsData>();
  static readonly SEND_VARIATION_LIST_PAGING_EVENT = new TypedEvent<AdobeAnalyticsData>();

  static selectAllAttrs = (model: TooltipAttrModel) =>
    model.values?.forEach((v) => {
      v.selectedValueMatch = true;
    });

  static clearAllAttrs = (model: TooltipAttrModel) =>
    model.values?.forEach((v) => {
      v.selectedValueMatch = false;
    });

  static changeAttr = (model: TooltipAttrModel, index: number, checked: boolean) => {
    let attr = model.values ? model.values[index] : undefined;
    if (attr) {
      attr.selectedValueMatch = checked;
    }
  };

  static searchBySelectedAttrs = (model: TooltipAttrModel, target: HTMLElement) => {
    const url = new URL(window.location.href);
    var queryParam = url.searchParams;
    queryParam.delete('page');
    const grpSpecSet = new Set(TableTooltipAction.getGrpSpecParams(url));

    model.values?.forEach((v) => {
      if (v.selectedValueMatch) {
        grpSpecSet.add(v.originalUrlParameter);
      } else {
        grpSpecSet.delete(v.originalUrlParameter);
      }
    });

    TableTooltipAction.deleteGrpSprcParams(url);
    grpSpecSet.forEach((spec) => url.searchParams.append(UrlParamKey.GrpSpec, spec));

    LoadingUtil.asyncPage(url.toString()).then((newDoc) => {
      VariationAction.REFRESH_TABLE.trigger(newDoc);
      TableTooltipAction.SEND_VARIATION_SEARCH_EVENT.trigger({
        linkName: 'vrSearchPjax',
        target: target
      });
    });
  };

  private static getGrpSpecParams = (url: URL) => {
    return url.searchParams.getAll(UrlParamKey.GrpSpec).concat(
      url.searchParams.getAll(UrlParamKey.GrpSpec1),
      url.searchParams.getAll(UrlParamKey.GrpSpec2),
      url.searchParams.getAll(UrlParamKey.GrpSpec3),
      url.searchParams.getAll(UrlParamKey.GrpSpec4),
      url.searchParams.getAll(UrlParamKey.GrpSpec5),
      url.searchParams.getAll(UrlParamKey.GrpSpec6),
      url.searchParams.getAll(UrlParamKey.GrpSpec7),
      url.searchParams.getAll(UrlParamKey.GrpSpec8),
      url.searchParams.getAll(UrlParamKey.GrpSpec9),
      url.searchParams.getAll(UrlParamKey.GrpSpec10),
      url.searchParams.getAll(UrlParamKey.GrpSpec11),
      url.searchParams.getAll(UrlParamKey.GrpSpec12),
      url.searchParams.getAll(UrlParamKey.GrpSpec13),
      url.searchParams.getAll(UrlParamKey.GrpSpec14),
      url.searchParams.getAll(UrlParamKey.GrpSpec15),
      url.searchParams.getAll(UrlParamKey.GrpSpec16),
      url.searchParams.getAll(UrlParamKey.GrpSpec17),
      url.searchParams.getAll(UrlParamKey.GrpSpec18),
      url.searchParams.getAll(UrlParamKey.GrpSpec19),
      url.searchParams.getAll(UrlParamKey.GrpSpec20),
      url.searchParams.getAll(UrlParamKey.GrpSpec21),
      url.searchParams.getAll(UrlParamKey.GrpSpec22),
      url.searchParams.getAll(UrlParamKey.GrpSpec23),
      url.searchParams.getAll(UrlParamKey.GrpSpec24),
      url.searchParams.getAll(UrlParamKey.GrpSpec25),
      url.searchParams.getAll(UrlParamKey.GrpSpec26),
      url.searchParams.getAll(UrlParamKey.GrpSpec27),
      url.searchParams.getAll(UrlParamKey.GrpSpec28),
      url.searchParams.getAll(UrlParamKey.GrpSpec29),
      url.searchParams.getAll(UrlParamKey.GrpSpec30)
    );
  }

  private static deleteGrpSprcParams = (url: URL) => {
    url.searchParams.delete(UrlParamKey.GrpSpec);
    url.searchParams.delete(UrlParamKey.GrpSpec1);
    url.searchParams.delete(UrlParamKey.GrpSpec2);
    url.searchParams.delete(UrlParamKey.GrpSpec3);
    url.searchParams.delete(UrlParamKey.GrpSpec4);
    url.searchParams.delete(UrlParamKey.GrpSpec5);
    url.searchParams.delete(UrlParamKey.GrpSpec6);
    url.searchParams.delete(UrlParamKey.GrpSpec7);
    url.searchParams.delete(UrlParamKey.GrpSpec8);
    url.searchParams.delete(UrlParamKey.GrpSpec9);
    url.searchParams.delete(UrlParamKey.GrpSpec10);
    url.searchParams.delete(UrlParamKey.GrpSpec11);
    url.searchParams.delete(UrlParamKey.GrpSpec12);
    url.searchParams.delete(UrlParamKey.GrpSpec13);
    url.searchParams.delete(UrlParamKey.GrpSpec14);
    url.searchParams.delete(UrlParamKey.GrpSpec15);
    url.searchParams.delete(UrlParamKey.GrpSpec16);
    url.searchParams.delete(UrlParamKey.GrpSpec17);
    url.searchParams.delete(UrlParamKey.GrpSpec18);
    url.searchParams.delete(UrlParamKey.GrpSpec19);
    url.searchParams.delete(UrlParamKey.GrpSpec20);
    url.searchParams.delete(UrlParamKey.GrpSpec21);
    url.searchParams.delete(UrlParamKey.GrpSpec22);
    url.searchParams.delete(UrlParamKey.GrpSpec23);
    url.searchParams.delete(UrlParamKey.GrpSpec24);
    url.searchParams.delete(UrlParamKey.GrpSpec25);
    url.searchParams.delete(UrlParamKey.GrpSpec26);
    url.searchParams.delete(UrlParamKey.GrpSpec27);
    url.searchParams.delete(UrlParamKey.GrpSpec28);
    url.searchParams.delete(UrlParamKey.GrpSpec29);
    url.searchParams.delete(UrlParamKey.GrpSpec30);
  }

  static searchBySelectedSellUnits = (model: TooltipAttrModel, target: HTMLElement) => {
    const url = new URL(window.location.href);
    var queryParam = url.searchParams;
    queryParam.delete('page');
    const sellUnitSet = new Set(url.searchParams.getAll(UrlParamKey.sellUnit));

    model.values?.forEach((v) => {
      if (v.selectedValueMatch) {
        sellUnitSet.add(v.originalUrlParameter);
      } else {
        sellUnitSet.delete(v.originalUrlParameter);
      }
    });

    url.searchParams.delete(UrlParamKey.sellUnit);
    sellUnitSet.forEach((sellUnit) =>
      url.searchParams.append(UrlParamKey.sellUnit, sellUnit)
    );

    LoadingUtil.asyncPage(url.toString()).then((newDoc) => {
      VariationAction.REFRESH_TABLE.trigger(newDoc);
      TableTooltipAction.SEND_VARIATION_SEARCH_EVENT.trigger({
        linkName: 'vrSearchPjax',
        target: target
      });
    });
  };

  static sortPriceAsc = (event: Event) => TableTooltipAction.sortPrice(Sort.asc, event);

  static sortPriceDesc = (event: Event) => TableTooltipAction.sortPrice(Sort.desc, event);

  private static sortPrice = (sortDir: Sort, event: Event) => {
    const url = new URL(window.location.href);
    url.searchParams.set(UrlParamKey.SortDir, sortDir);

    const target = event.currentTarget as HTMLElement;
    LoadingUtil.asyncPage(url.toString()).then((newDoc) => {
      VariationAction.REFRESH_TABLE.trigger(newDoc);
      TableTooltipAction.SEND_VARIATION_SEARCH_EVENT.trigger({
        linkName: 'vrSearchPjax',
        target: target
      });
    });
  };

  static selectAllTableTxHeader = (model: TableTxFilterHeaderModel) => {
    let checkbox: any = document.getElementsByClassName("checkbox_filter");
    for (var i = 0; i < checkbox.length; i++) {
      checkbox[i].checked = true;
    }
    model.headers.forEach((v) => (v.shouldShown = true));
  };

  static closeModel = () => {
    let model: any = document.getElementById("filter_header_trigger");
    model?.classList.remove("is-shown");
    model?.querySelector('.m-tooltipContent_target')?.setAttribute('style', '');
  }

  static clearAllTableTxHeader = (model: TableTxFilterHeaderModel) => {
    let checkbox: any = document.getElementsByClassName("checkbox_filter");
    for (var i = 0; i < checkbox.length; i++) {
      checkbox[i].checked = false;
    }
    model.headers.forEach((v) => (v.shouldShown = false));
  };

  static changeTableTxHeader = (model: TableTxFilterHeaderModel) => {
    const indexList: number[] = [];
    model.headers.forEach((header, index) => {
      TableTooltipAction.changeStyleDisplay(index, header.shouldShown ? 'table-cell' : 'none');

      const element = document.getElementById(TABLE_GROUP_SPEC_COL + index);
      if (header.shouldShown) {
        indexList.push(index);
        if (header.checkIsSelected && element) {
          element.classList.add(SELECTED_CLASS);
        }
      } else {
        if (header.checkIsSelected && element) {
          element.classList.remove(SELECTED_CLASS);
        }
      }
    });

    document
      .querySelector('#variations-table-all-area')
      ?.setAttribute(DATA_HEADER_COLS, indexList.toString());

    if (isIe) {
      TableTooltipAction.adjustSideWidthAndHeightForIe();
    }

    // 表示項目設定で表示列を絞った際に、表のヘッダの高さのサイズ調整処理を実行
    TableTooltipAction.adjustTableHeaderHeightForNoImageVariation()

    TableTooltipAction.closeModel();
  };

  private static changeStyleDisplay = (index: number, styleName: string) => {
    document
      .querySelectorAll(`.${TABLE_GROUP_SPEC_COL}${index}`)
      .forEach((e) => ((e as HTMLLIElement).style.display = styleName));
  };

  // IEで固定列の高さとスクロール列の高さを揃えるために2つテーブルが存在している（以下、元テーブルと複製テーブルと呼ぶ）
  // see: https://github.com/askul/trylion-phase1-club-template/blob/develop/src/cms/assets/js/ieStickyCol.ts
  //
  // ◆幅の調整について
  // ヘッダの表示項目の数が少なくなると、元テーブルの固定列の幅が変更されるが、css属性にvisibility: hiddenが設定されるため、
  // 元テーブルのスクロール列が右寄せに見えてしまう。
  // そのため複製テーブルの幅と元テーブルの固定列の幅と一致する必要がある。
  // 詳細な図解は以下のチケットの添付ファイル8328_23_8.xlsxをご参照ください。
  // http://34.92.19.111/issues/8328
  // ◆高さの調整について
  // 比較軸は内容によってタイトル行の高さが異なってくる
  // 例えば内容が長い比較軸を表示項目から外すと元テーブルのタイトル行が低くなる、そのため複製テーブルも高さの調整が必要
  private static adjustSideWidthAndHeightForIe() {
    const originalTable = document.querySelector('.js-hasStickyCol .o-table_inner:not(.is-clone)') as HTMLElement;
    const cloneTable = document.querySelector('.js-hasStickyCol .o-table_inner.is-clone') as HTMLElement;
    if (cloneTable) {
      // 幅を調整
      const sideWidth = originalTable?.querySelector('thead th')?.clientWidth;
      cloneTable.style.width = `${sideWidth}px`;
      // 高さを調整
      const titleHeight = originalTable?.querySelector('thead th')?.clientHeight;
      const cloneTitleElement = cloneTable.querySelector('thead th') as HTMLElement;
      if (cloneTitleElement) {
        cloneTitleElement.style.height = `${titleHeight}px`;
      }
    }
  }

  // 画像無しバリエの商品一覧の表（スクロールあり）のヘッダの高さのサイズ調整処理を実行
  // pub-SLP-SRC-031.jsで実行する処理と同じだがwindowに紐付けするまでもないのでこちらに同じ処理をそのまま記載している
  static adjustTableHeaderHeightForNoImageVariation() {
    const sourceHeight = document.querySelector<HTMLElement>('.js-variation-table_adjustSource')?.offsetHeight;
    const target = document.querySelectorAll<HTMLElement>('.js-variation-table_adjust');
    target?.forEach(el => {
      el.style.height = sourceHeight + 'px';
    });
  }
}
